import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "CustomerThirdPartyStatistics" }
const _hoisted_2 = { style: {"align-items":"center","display":"inline-flex","margin":"0 auto"} }
const _hoisted_3 = { style: {"margin-left":"10px"} }

import { searchFormConfig } from './config/search.config'
import { contentTableConfig } from './config/content.config'
import PageContent from '@/components/PageContent.vue'
import { getListData } from '@/service/main/system'
import { useStore } from '@/store'
import { initEmptyParam } from '@/hooks/useInitParam'
import { ElMessage } from 'element-plus'
import { ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'CustomerThirdPartyStatistics',
  setup(__props) {

initEmptyParam()
const store = useStore()
const pageContentRef = ref<InstanceType<typeof PageContent>>()

const getUsedBy = async () => {
  const userList = await getListData(
    '/main/enterpriseWechat/dingUser/listAll',
    {}
  )
  const usedByItem = searchFormConfig.formItems.find(
    (item) => item.field === 'usedBy'
  )
  if (usedByItem) {
    usedByItem.options = userList.map((item: any) => {
      return { title: item.userName, value: item.userName }
    })
  }
}
getUsedBy()

const getThirdPartyList = async () => {
  try {
    const thirdPartyData = await getListData(
      '/main/customerChannel/queryMainThirdParty',
      {}
    )
    const thirdPartyItem = searchFormConfig.formItems.find(
      (item) => item.field === 'thirdParty'
    )
    if (thirdPartyItem) {
      thirdPartyItem.options = thirdPartyData.map((item: any) => {
        return { title: item, value: item }
      })
    }
  } catch (error) {
    console.error('获取第三方列表失败', error)
  }
}
getThirdPartyList()

const clearTableData = () => {
  store.commit('system/changeCustomerStatisticsList', [])
  store.commit('system/changeCustomerStatisticsCount', 0)
}
clearTableData()

const handleResetClick = () => {
  store.commit('system/changeQueyryInfo', {})
  clearTableData()
}

const handleSearchClick = (formdata: any) => {
  if (!formdata.thirdParty) {
    ElMessage.warning('请选择所属第三方')
    return
  }

  pageContentRef.value?.getPageData({ ...formdata })
}

const handleSortChange = (value: any) => {
  const queryInfo = store.state.system.queryInfo
  if (!queryInfo.thirdParty) {
    ElMessage.warning('请选择所属第三方')
    return
  }

  store.commit('system/changeOrderInfo', {
    orderBy: value.prop,
    orderType: value.order
  })
  pageContentRef.value?.getPageData(queryInfo)
}

const handleDownBtnClick = () => {
  if (!store.state.system.queryInfo.thirdParty) {
    ElMessage.warning('请选择所属第三方')
    return
  }

  pageContentRef.value?.exportXlsx(store.state.system.queryInfo)
}

return (_ctx: any,_cache: any) => {
  const _component_PageSearch = _resolveComponent("PageSearch")!
  const _component_el_avatar = _resolveComponent("el-avatar")!
  const _component_el_tag = _resolveComponent("el-tag")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageSearch, {
      searchFormConfig: _unref(searchFormConfig),
      onResetBtnClick: handleResetClick,
      onSearchBtnClick: handleSearchClick
    }, null, 8, ["searchFormConfig"]),
    _createVNode(PageContent, {
      ref_key: "pageContentRef",
      ref: pageContentRef,
      contentTableConfig: _unref(contentTableConfig),
      pageName: "customerStatistics",
      pageUrl: "/main/customerStatistics/queryByCondition",
      downUrl: "/main/customerStatistics/download",
      downFilename: "客户列表.xlsx",
      onSortChange: handleSortChange,
      onDownBtnClick: handleDownBtnClick
    }, {
      consumer: _withCtx((scope) => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_el_avatar, {
            shape: "square",
            size: 30,
            src: scope.row.avatar
          }, null, 8, ["src"]),
          _createElementVNode("span", _hoisted_3, _toDisplayString(scope.row.uname) + " (" + _toDisplayString(scope.row.remark) + ") ", 1)
        ])
      ]),
      isRepeat: _withCtx((scope) => [
        _createVNode(_component_el_tag, {
          type: scope.row.isRepeat == 1 ? 'danger' : 'info',
          effect: scope.row.isRepeat == 1 ? 'dark' : 'plain',
          size: "small"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(scope.row.isRepeat == 1 ? '重复客户' : '非重复'), 1)
          ]),
          _: 2
        }, 1032, ["type", "effect"])
      ]),
      isRepeatWithinSixMonth: _withCtx((scope) => [
        _createVNode(_component_el_tag, {
          type: scope.row.isRepeatWithinSixMonth == 1 ? 'danger' : 'info',
          effect: scope.row.isRepeatWithinSixMonth == 1 ? 'dark' : 'plain',
          size: "small"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(scope.row.isRepeatWithinSixMonth == 1 ? '是' : '否'), 1)
          ]),
          _: 2
        }, 1032, ["type", "effect"])
      ]),
      isDeletedWithin24Hours: _withCtx((scope) => [
        _createVNode(_component_el_tag, {
          type: scope.row.isDeletedWithin24Hours == 1 ? 'danger' : 'info',
          effect: scope.row.isDeletedWithin24Hours == 1 ? 'dark' : 'plain',
          size: "small"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(scope.row.isDeletedWithin24Hours == 1 ? '是' : '否'), 1)
          ]),
          _: 2
        }, 1032, ["type", "effect"])
      ]),
      isInAfterSales: _withCtx((scope) => [
        _createVNode(_component_el_tag, {
          type: scope.row.isInAfterSales == 1 ? 'success' : 'info',
          effect: scope.row.isInAfterSales == 1 ? 'dark' : 'plain',
          size: "small"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(scope.row.isInAfterSales == 1 ? '是' : '否'), 1)
          ]),
          _: 2
        }, 1032, ["type", "effect"])
      ]),
      remarkTags: _withCtx((scope) => [
        _createElementVNode("span", null, _toDisplayString(_ctx.getRemarkTagText(scope.row.remark)), 1)
      ]),
      _: 1
    }, 8, ["contentTableConfig"])
  ]))
}
}

})